<template>
  <div
    class="w-full flex flex-col items-center justify-center gap-4 py-[50px] bg-[url('@/assets/imgs/pageDown/down_bg.png')] bg-cover bg-center"
  >
    <div class="text-[#E57B7B] text-[30px] font-bold text-center [@media(max-width:1280px)]:px-[60px]">
      YOUR DAILY COMPANION TO SEEK FAITH<br />
      AND PURPOSE!
    </div>
    <img src="@/assets/imgs/pageDown/download.png" alt="download" class="w-[100px] cursor-pointer" @click="handleDownloadClick" />
  </div>
</template>
<script setup lang="ts">
import { sendTA } from '@/assets/js/TA'

function handleDownloadClick() {
  sendTA('XWEB_CLICK', {
    name: 'android_download_click',
  })
  window.open('https://play.google.com/store/apps/details?id=com.liotek.lannbible', '_blank')
}
</script>
